import {AfterViewInit, Component, ViewChild, ChangeDetectionStrategy, inject} from '@angular/core';
import {ModalComponent} from "../../../libs/modal/modal.component";
import {TranslatePipe} from "@ngx-translate/core";
import {DeactivateDialogService} from "../deactivate-dialog.service";
import {ModalConfig} from "../../../libs/modal/modal.config";

@Component({
  selector: 'acc-deactivate-dialog',
  imports: [
    ModalComponent,
    TranslatePipe
  ],
  templateUrl: './deactivate-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './deactivate-dialog.component.css'
})
export class DeactivateDialogComponent implements AfterViewInit {
  private readonly deactivateDialogService = inject(DeactivateDialogService);

  @ViewChild('leaveConfirm')
  public leaveConfirm!: ModalComponent;

  @ViewChild('waitDialog')
  public waitDialog!: ModalComponent;

  protected readonly modalLeaveConfig = new ModalConfig({
    deleteConfirmMsgCode: 'deactivate.dialog.leave.confirm',
    deleteCancelMsgCode: 'deactivate.dialog.leave.cancel'
  });

  private resolve: ((result: boolean) => void) | undefined;

  ngAfterViewInit(): void {
    this.deactivateDialogService.setDeactivateDialog(this);
  }

  public isOpen(): boolean {
    return (this.leaveConfirm.isOpen() || this.waitDialog.isOpen());
  }

  public openLeave(): Promise<boolean> {
    this.close();
    this.leaveConfirm.open().then();
    return new Promise<boolean>((res) => this.resolve = res);
  }

  public openWait(): void {
    this.close();
    this.waitDialog.open().then();
  }

  public close(): void {
    if (this.leaveConfirm.isOpen()) {
      this.leaveConfirm.close();
    }
    if (this.waitDialog.isOpen()) {
      this.waitDialog.close();
    }
  }

  protected confirmed(): void {
    if (this.resolve) {
      this.resolve(true);
    }
  }

  protected canceled(): void {
    if (this.resolve) {
      this.resolve(false);
    }
  }
}
